module.exports = __webpack_public_path__ + "img/lg_ring_y_l_null_null@3x.51352d73.png";